import { render, staticRenderFns } from "./zdcgjlList.vue?vue&type=template&id=1969f80e"
import script from "./zdcgjlList.vue?vue&type=script&lang=js"
export * from "./zdcgjlList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports